import * as React from 'react';
import styled from 'styled-components';

import { StyledTextField } from '@process-advisor/process-miner/model/statistics/styledTextField';

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    padding: 5px 0;
`;

type Props = {
    value: number;
    disabled?: boolean
};

export const NumberInput: React.FC<Props> = ({
    value,
}) => (
    <Wrapper>
        <StyledTextField
            value={value}
            variant="outlined"
            type="string" />
    </Wrapper>
);
